/*
 * @Author: M.D.
 * @Date: 2019-12-16 10:00:52
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import ProductAPI from './prd-api'
import UsrApi from './usr-api'
import IdxApi from './idx-api'
import OthApi from './oth-api'
import OrdApi from './ord-api'
import Robot from './robot'
import QdpApi from './qdp-api'

const API = {
  ...UsrApi,
  ...ProductAPI,
  ...IdxApi,
  ...OthApi,
  ...OrdApi,
  ...Robot,
  ...QdpApi
}

export default API
